import React, { useMemo, useState, useRef, useCallback, useEffect } from "react";
import { useAuth } from '../../hooks/useAuth';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { check_admin_access } from '../../helpers/AccessHelper'
import axiosWithAuth from "../../helpers/AxiosHelper";
import errorMessage from "../../helpers/errorMessage";
import { PLATFORM_CONFIGURATION_COLUMNS, MONITORING_COLUMNS } from './monitoringColumns';
import PageHeader from '../common/PageHeader';
import "./monitoring.css";
import "../../../node_modules/primeflex/primeflex.css";
import "primereact/resources/themes/lara-light-indigo/theme.css"
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
// const style = {
//   testTransform: "uppercase",
//   fontsize: "30px",
//   color: "black",
// };

function Monitoring(props) {

  const { groups } = useAuth();
  const [monitorPlatformRowData, setMonitorPlatformRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  const [monitorInternalRowData, setMonitorInternalRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  const [scoreData, setScoreData] = useState();
  const [scoreLoader, setScoreLoader] = useState(false);
  const [platformLoader, setPlatformLoader] = useState(false);
  const [internalLoader, setInternalLoader] = useState(false);
  const [platformsList, setPlatformsList] = useState()
  const setLoadingInProps = props.setLoading;
  const config_columns = PLATFORM_CONFIGURATION_COLUMNS;  
  const [expanded, setExpanded] = useState(false);

  const [filters, setFilters] = useState({
    platformName: { value: "", matchMode: "contains" }
  });
  // const monitor_columns = MONITORING_COLUMNS;

  useEffect(() => {
    // setLoadingInProps(true);
    setPlatformLoader(true);
    setInternalLoader(true);
    setScoreLoader(true);
    axiosWithAuth.get("/monitoring/platform")
      .then(data => {
        let platformsList = []
        for (let singlePlatform of data.data) {
          if (!platformsList.includes(singlePlatform['platform']))
            platformsList.push(singlePlatform['platform'])
        }
        setPlatformsList(platformsList)
        setMonitorPlatformRowData(data.data)
        setPlatformLoader(false);
        // setLoadingInProps(false);
      }).catch(err => {
        console.error('Originator monitoring fetch failed:', errorMessage(err))
      });
    axiosWithAuth.get("/monitoring/internal")
      .then(data => {
        setMonitorInternalRowData(data.data)
        setInternalLoader(false);
        // setLoadingInProps(false);
      }).catch(err => {
        console.error('Internal monitoring fetch failed:', errorMessage(err))
      });
    axiosWithAuth.get("/monitor-score")
      .then(data => {
        setScoreData(data.data)
        setScoreLoader(false);
        // setLoadingInProps(false);
      }).catch(err => {
        console.error('Score monitoring fetch failed:', errorMessage(err))
      });
  }, []);

  const headerWithSubtitle = (title, subtitle) => (
    <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
      <span style={{ fontWeight: 600 }}>{title}</span>
      <small style={{ fontSize: "11px", color: "var(--app-text-muted)", textTransform: "none", letterSpacing: 0 }}>{subtitle}</small>
    </div>
  );

  // const issuesTemplate = row => tagTemplate(row, "ohe_issues");
  // const missingTemplate = row => tagTemplate(row, "missing_columns");
  // const nullTemplate = row => tagTemplate(row, "nulls_columns");

  const platformOptions = Array.isArray(scoreData)
    ? Array.from(new Set(scoreData.map(item => item.platformName)))
      .map(name => ({ label: name, value: name }))
    : [];

  // const cellEditor = (options) => {
  //   if (options.field === 'spro_upload' || options.field === 'validate')
  //     return textEditor(options);
  // }

  // const textEditor = (options) => {
  //   return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
  // }

  // const onCellEditComplete = (e) => {
  //   let { rowData, newValue, field, originalEvent: event } = e;

  //   switch (field) {
  //     default:
  //       if (newValue.trim().length > 0)
  //         rowData[field] = newValue;
  //       else
  //         event.preventDefault();
  //       break;
  //   }
  // }


  // const dynamicColumnsMonitoring = config_columns.map((col, i) => {
  //   return <Column key={col.field} field={col.field} header={col.header} body={col.body} sortable={col.sortable} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
  // })
  const PlatformRowFilterTemplate = (options) => {
    return <Dropdown value={options.value} options={platformsList} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select an Originator" className="p-column-filter" showClear />;
  }


  const dynamicColumnsPlatformMonitoring = MONITORING_COLUMNS.map((col, i) => {
    if (col.field === 'platform')
      return <Column key={col.field} field={col.field} header={col.header} body={col.body} sortable={col.sortable} filter={col.filter} filterField={col.filterField} />
    else
      return <Column key={col.field} field={col.field} header={col.header} body={col.body} sortable={col.sortable} filter={col.filter} filterField={col.filterField} filterPlaceholder={col.filterPlaceholder} filterElement={col.filterElement} />
  })

  // const dynamicColumnsInternalMonitoring = config_columns.map((col, i) => {
  //   return <Column key={col.field} field={col.field} header={col.header} body={col.body} sortable={col.sortable} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
  // })
  const expandableTagTemplate = (field, previewCount = 3) => (row) => {
    const obj = row[field];
    if (!obj || Object.keys(obj).length === 0) return "None";

    const entries = Object.entries(obj);

    const visibleEntries = expanded ? entries : entries.slice(0, previewCount);

    return (
        <div>
            <div className="flex flex-wrap gap-2">
                {visibleEntries.map(([key, value]) => (
                    <Tag key={key} value={`${key}: ${value}`} />
                ))}
            </div>
            {entries.length > previewCount && (
                <Button
                    text
                    label={expanded ? "Show less" : `Show more (${entries.length - previewCount})`}
                    onClick={() => setExpanded(!expanded)}
                    className="p-button-text p-button-sm monitoring-show-more"
                    style={{ padding: 0, marginTop: '0.25em' }}
                />
            )}
        </div>
    );
};

  return (
    <div className="content-container">
      <div style={{ maxWidth: "100%", maxHeight: "100%", minHeight: "50%" }}>
        <PageHeader
          title="Monitoring"
          subtitle="Originator file checks, internal pipeline runs and score quality."
          icon="pi-eye"
        />
        <TabView>
          {check_admin_access(groups) && <TabPanel header="Originator Monitoring">
            <DataTable value={monitorPlatformRowData} showGridlines dataKey="_key" loading={platformLoader} filterDisplay="row"
              paginator paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={5} rowsPerPageOptions={[5, 10, 20, 50]} responsiveLayout="scroll" stripedRows sortField="update_date"
            >
              {dynamicColumnsPlatformMonitoring}
            </DataTable>
          </TabPanel>}

          {check_admin_access(groups) && <TabPanel header="Internal Monitoring">
            <DataTable value={monitorInternalRowData} showGridlines dataKey="_key" loading={internalLoader}
              paginator paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={5} rowsPerPageOptions={[5, 10, 20, 50]} responsiveLayout="scroll" stripedRows sortField="update_date"
            >
              {dynamicColumnsPlatformMonitoring}
            </DataTable>
          </TabPanel>}

          {<TabPanel header="Score Monitoring">
            <DataTable value={scoreData} paginator rows={10} tableStyle={{ minWidth: '60rem' }} onFilter={(e) => setFilters(e.filters)} filters={filters} loading={scoreLoader}>

              <Column field="platformName" header="Originator" sortable filter
                filterElement={
                  <Dropdown
                    value={filters.platformName?.value || null}
                    options={platformOptions}
                    placeholder="Select Originator"
                    onChange={(e) =>
                      setFilters(prev => ({
                        ...prev,
                        platformName: { value: e.value, matchMode: "equals" }
                      }))
                    }
                    showClear
                  />
                } />
              <Column field="score" header="Score" sortable />
              <Column field="number_of_loans" header="Loans" sortable />

              {/* Custom renderers for objects */}
              <Column header={headerWithSubtitle("OHE Issues", "{column : count}")} body={expandableTagTemplate('ohe_issues')} />
              <Column header={headerWithSubtitle("Missing Columns", "{column : count}")} body={expandableTagTemplate('missing_columns')} />
              <Column header={headerWithSubtitle("Null Columns", "{column : count}")} body={expandableTagTemplate('null_columns')} />

            </DataTable>

          </TabPanel>}

        </TabView>
      </div>
    </div>
  );
};

export default Monitoring;